module.exports = __webpack_public_path__ + "static/img/bg1.e5686b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/bg1.jpg
// module id = e94U
// module chunks = 0